export default __webpack_public_path__ + "static/media/australia.262fdf96.png";